export default __webpack_public_path__ + "static/media/AST.c41b3375.svg";